import { getStore } from 'owa-mail-reading-pane-store/lib/store/Store';
import { mutatorAction } from 'satcheljs';

export const updateShouldExpandAllItemPartsMutator = mutatorAction(
    'updateShouldExpandAllItemPartsMutator',
    (shouldExpandAll: boolean) => {
        getStore().shouldExpandAllItemParts = shouldExpandAll;
    }
);
